<div class="page-container">
  <div class="page-header mb-3 mb-lg-4">
    <h1 class="mb-0">Listings & Bookings</h1>
  </div>

  <div class="grid-container d-flex flex-column gap-4 w-100">
    <div class="w-100">
      <ul class="nav nav-tabs d-flex justify-content-between flex-nowrap">
        <div style="display: flex">
          <li class="nav-item" *ngFor="let tab of tabs">
            <span class="nav-link" style="cursor: pointer" [ngClass]="{ active: tab.position === activeTab }" (click)="updateCustomerActiveTab(tab.backend_name)">{{ tab.name }}</span>
          </li>
        </div>

        <li class="nav-item">
          <span class="nav-link" style="cursor: pointer" (click)="switchView()"><u>Switch to Classic View</u></span>
        </li>
      </ul>
    </div>
    <div [ngSwitch]="activeTab" class="w-100">
      <div *ngSwitchCase="0">
        <app-shipment-listing></app-shipment-listing>
      </div>
      <div *ngSwitchCase="1">
        <app-shipment-bookings></app-shipment-bookings>
      </div>
    </div>
  </div>
</div>
